import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes';
import type { ReactNode } from 'react';

const router = createBrowserRouter(routes);

export function AppRouter(): ReactNode {
  return <RouterProvider router={router} />;
}
